import { useState, useEffect } from "react";
import Select from 'react-select';
import { BusinessLoader } from "./BusinessLoader";
import { businessIdHeader, businessesHeader, cssFormInputDropdown, enabledContactRequestHeader } from "./Library";

export class BusinessOption {
	constructor(key, text) {
		this.label = text;
		this.value = key;
	}
}

export function BusinessSelector() {
	const { loading, businesses, currentBusiness } = BusinessLoader();

	const options = businesses.map(b => new BusinessOption(b.businessId, b.businessName));

	const [selectedBusiness, setSelectedBusiness] = useState(
		currentBusiness
			? new BusinessOption(currentBusiness.businessId, currentBusiness.businessName)
			: null
	);

	const SaveBusinessAndReload = (event) => {
		const allBusinesses = JSON.parse(sessionStorage.getItem(businessesHeader));

		var selectedBusiness = allBusinesses.find(bu => bu.businessId === event.value);
		sessionStorage.setItem(businessIdHeader, JSON.stringify(event.value));
		sessionStorage.setItem(enabledContactRequestHeader, JSON.stringify(selectedBusiness.enabledContactRequests));
		setSelectedBusiness(event);
		window.location.reload();
	};

	const DisplayBusinessDropdown = () => {
		return options.length > 1 ?
			(<label>
				Business<Select
					className={cssFormInputDropdown}
					placeholder='Select Business'
					fluid
					selection
					search
					options={options.sort((a, b) => a.label.localeCompare(b.label))}
					name="businessId"
					onChange={(e) => SaveBusinessAndReload(e)}
					value={new BusinessOption(currentBusiness.businessId, currentBusiness.businessName)}
				/>
			</label>

			) : "";
	};

	let businessDropdown = loading ? <p><em>Loading</em></p> : DisplayBusinessDropdown();

	return (
		<>
			{businessDropdown}
		</>
	);
}
